import React from 'react';
import { Table } from 'semantic-ui-react';

// GLobal Components
import RoleTable from 'components/RoleTable';

// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import { ADMIN } from 'components/RoleGate/constants';

import { IncompleteWeatherSprayEvent } from '../../types';
import CompleteCropSprayEventFormTableWeatherRow from './components/CompleteCropSprayEventFormTableWeatherRow';
import WeatherTableHeader from '../CompleteCropSprayEventFormTableHeader/components/WeatherTableHeader';

interface OwnProps {
    incompleteSprayEvents: Record<string, IncompleteWeatherSprayEvent[]>;
}

type Props = OwnProps;

export default function CompleteCropSprayEventFormTableWeather(
    props: Props
): React.ReactElement {
    const { incompleteSprayEvents } = props;

    return (
        <ResponsiveTable>
            <RoleTable requiredRoles={[ADMIN]}>
                <WeatherTableHeader />
                <Table.Body>
                    {Object.keys(incompleteSprayEvents).map((startDate) =>
                        incompleteSprayEvents[startDate].map(
                            (sprayEvent, index) => (
                                <CompleteCropSprayEventFormTableWeatherRow
                                    sprayEvent={sprayEvent}
                                    index={index}
                                    key={sprayEvent.key}
                                />
                            )
                        )
                    )}
                </Table.Body>
            </RoleTable>
        </ResponsiveTable>
    );
}
